import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "../../lib/api";
import { toast } from "sonner";

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => api.get("/admin/customers").then((r) => { setCustomers(r.data); setLoading(false); });
  useEffect(() => { load(); }, []);
  const saveNote = async (c, notes) => { await api.patch(`/admin/customers/${c.id}`, { notes }); toast.success("Note enregistrée"); };
  if (loading) return <div className="grid place-items-center h-64"><Loader2 className="w-10 h-10 animate-spin text-brand" /></div>;

  return (
    <div>
      <h1 className="font-heading font-extrabold text-3xl text-ink mb-8">Clients</h1>
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-x-auto">
        <table className="w-full text-left min-w-[800px]">
          <thead className="bg-slate-50 text-ink-muted text-sm"><tr><th className="p-4">Client</th><th className="p-4">Contact</th><th className="p-4">Langue</th><th className="p-4">Résa</th><th className="p-4">Dépensé</th><th className="p-4">Notes internes</th></tr></thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.id} className="border-t border-slate-50">
                <td className="p-4 font-semibold text-ink">{c.first_name} {c.last_name}</td>
                <td className="p-4 text-sm">{c.email}<br />{c.phone}</td>
                <td className="p-4 uppercase">{c.lang}</td>
                <td className="p-4">{c.bookings_count}</td>
                <td className="p-4 font-bold text-brand">{c.total_spent?.toFixed(2)} €</td>
                <td className="p-4"><input defaultValue={c.notes} onBlur={(e) => saveNote(c, e.target.value)} placeholder="Ajouter une note..." className="w-full h-10 rounded-lg border-2 border-slate-200 px-2 text-sm" /></td>
              </tr>
            ))}
          </tbody>
        </table>
        {customers.length === 0 && <p className="p-8 text-center text-ink-muted">Aucun client.</p>}
      </div>
    </div>
  );
};

export default Customers;
